<div class="initiative"
  [ngClass]="{'empty' : initiative <= 0 && figure.initiative <= 0 && (!settingsManager.settings.initiativeRequired || character && character.exhausted)}"
  [ghs-label]="'game.figure.setInitiative'" [ghs-label-attribute]="'title'">
  <img (click)="open($event)" class="ghs-svg" src="./assets/images/initiative.svg" />
  <input [ngClass]="{'hidden' : hidden}" #initiativeInput [value]="initiativeValue" (change)="updateInitiative($event)"
    (focus)="initiativeInput.select()" type="number" (blur)="disableReveal()" [min]="min" max="99" maxlength="2"
    [id]="id">
  @if (figure.initiative > 0 && initiativeHidden && !reveal) {
  <span class="hidden-initiative" (click)="enableReveal($event)">??</span>
  }
  @if (!!character && !initiativeHidden && character.longRest) {
  <img class="ghs-svg long-rest" [ghs-label]="'game.figure.longRestOff'" [ghs-label-attribute]="'title'"
    src="./assets/images/long-rest.svg" (click)="longRestOff($event)" />
  }
</div>